// extracted by mini-css-extract-plugin
module.exports = {"row":"shared_row__ytHA8","swatch":"shared_swatch__HXtu_"};